import { Component, ViewChild } from '@angular/core';
import {
  PoBreadcrumb,
  PoDialogService,
  PoNotificationService,
  PoUploadComponent
} from '@po-ui/ng-components';
import { ConciliacaoFornecedoresService } from './conciliacao-fornecedores.service';

@Component({
  selector: 'app-conciliacao-fornecedores',
  templateUrl: './conciliacao-fornecedores.component.html',
  styleUrls: ['./conciliacao-fornecedores.component.css'],
  standalone: false
})
export class ConciliacaoFornecedoresComponent {
  @ViewChild('upload', { static: true }) upload!: PoUploadComponent;

  loading = false;
  codiEmp = '';
  contaFornecedores = '';
  restrictions = { allowedExtensions: ['.xlsx'] };
  urlPlaceholder = 'https://po-ui.io';

  readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Home', link: '/home' },
      { label: 'Contabilidade' },
      { label: 'Conciliação Fornecedores' }
    ]
  };

  constructor(
    private readonly conciliacaoService: ConciliacaoFornecedoresService,
    private readonly poNotification: PoNotificationService,
    private readonly poDialog: PoDialogService
  ) { }

  enviarConciliacao() {
    const files = this.upload?.currentFiles;
    if (!files?.length) {
      this.poNotification.warning('Selecione a planilha Excel da conciliação.');
      return;
    }

    const file = files[0] as any;
    const rawFile: File | undefined = file?.rawFile;
    if (!rawFile) {
      this.poNotification.warning('Arquivo inválido. Selecione novamente a planilha.');
      return;
    }

    this.loading = true;
    this.conciliacaoService
      .enfileirarConciliacao(rawFile, this.codiEmp, this.contaFornecedores)
      .subscribe({
        next: (result) => {
          this.loading = false;
          if (result?.error) {
            this.poNotification.error(result.error);
            return;
          }

          this.poDialog.alert({
            title: 'Conciliação Contas de Fornecedores',
            message:
              'Conciliação solicitada com sucesso. Em alguns minutos você receberá um e-mail com a planilha processada. ' +
              'Revise os resultados com atenção: a conciliação é baseada no histórico das contas e pode conter erros.'
          });

          this.upload.clear();
          this.codiEmp = '';
          this.contaFornecedores = '';
        },
        error: (err) => {
          this.loading = false;
          const msg =
            err?.error?.error ||
            err?.error?.message ||
            'Não foi possível enfileirar a conciliação.';
          this.poNotification.error(msg);
        }
      });
  }
}
